enum SearchType {
  ORGANIZATION = 'ORGANIZATION',
  ROBOT = 'ROBOT',
  USER = 'USER',
}

export default SearchType;
